/**
 * @generated SignedSource<<73100ab6f2ac1848b42fcbc622bc2f13>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type atomsCurrentTakeoverAdSectionsAtomBase$data = {
  readonly __typename: "Article";
  readonly sectionsV2: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId?: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "atomsCurrentTakeoverAdSectionsAtomBase";
} | {
  readonly __typename: "Section";
  readonly fullSectionPath: ReadonlyArray<{
    readonly entityId: string;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "atomsCurrentTakeoverAdSectionsAtomBase";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "atomsCurrentTakeoverAdSectionsAtomBase";
};
export type atomsCurrentTakeoverAdSectionsAtomBase$key = {
  readonly " $data"?: atomsCurrentTakeoverAdSectionsAtomBase$data;
  readonly " $fragmentSpreads": FragmentRefs<"atomsCurrentTakeoverAdSectionsAtomBase">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "atomsCurrentTakeoverAdSectionsAtomBase"
};

(node as any).hash = "d1e8ffa556be9d37bbb1aa7cc496dba2";

export default node;
